import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const anggaranPengeluaranTable = (
  handleEdit,
  handleDelete,
  handleShowDetail
) => {
  return [
    {
      title: "Id Anggaran",
      render: (rowData) => {
        return <span>{rowData.id_anggaran_pengeluaran}</span>;
      },
    },
    {
      title: "Unit Usaha",
      render: (rowData) => {
        return <span>{rowData.unit_usaha}</span>;
      },
    },
    {
      title: "Kode Akun",
      render: (rowData) => {
        return <span>{rowData.kode_akun}</span>;
      },
    },
    {
      title: "Nama Anggaran Pengeluaran",
      render: (rowData) => {
        return <span>{rowData.nama_anggaran_pengeluaran}</span>;
      },
    },
    {
      title: "Jumlah",
      render: (rowData) => {
        return (
          <span>{CurrencyFormat(rowData.jumlah_anggaran_pengeluaran)}</span>
        );
      },
    },
    {
      title: "Tahun",
      render: (rowData) => {
        return <span>{rowData.tahun_anggaran_pengeluaran}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
            <button
              className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleShowDetail(rowData)}
            >
              <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
            </button>
          </>
        );
      },
    },
  ];
};
